export default __webpack_public_path__ + "static/Statistical-Analysis-b27a96f1329e0239c4c981c57d422792.webp";